import React, { useState } from "react";
import { actionGetRptPtosConfig } from "../../../features/relatorios/rptPtosConfig/slices";
import factoryFields from "../../../helpers/factory-fields";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Button from "../../Button";
import Select from "../../Select";

const RptPtosConfig = () => {
  const [state, setState] = useState("");
  const dispatch = useAppDispatch();
  const { getRptPtosConfig } = useAppSelector((state) => state);

  const [value, setValue] = useState("");

  const handlerChange = (e: any) => {
    setValue(e.target.value);
    setState(e.target.value);
  };

  const handlerReportConfig = () => dispatch(actionGetRptPtosConfig(state));
  return (
    <div className="container">
      <div className="row">
        <div className="col-4">
          <div className="mb-20">
            <Select
              size="sm"
              label="Formato do arquivo"
              options={factoryFields.typesReport}
              value={value}
              onChange={handlerChange}
            />
          </div>
          <Button
            size="sm"
            onClick={handlerReportConfig}
            loading={getRptPtosConfig.status === "loading"}
          >
            Baixar Relatório
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RptPtosConfig
